<ion-card>
  <ion-card-header>
    <ion-card-title>Your Sites</ion-card-title>
    <div *ngIf="!listingComplete.multisiteCompleted(listing)" class="required-pill ion-float-end">
      <p class="paragraph">required</p>
    </div>
    <curbnturf-checked *ngIf="listingComplete.multisiteCompleted(listing)"> </curbnturf-checked>
  </ion-card-header>
  <ion-card-content class="ion-25-padding">
    <div class="_18-px-spacer"></div>
    <p>Below are the sites that have been added to your property. You can add more sites or copy data between the sites.</p>
    <div class="_18-px-spacer"></div>
    <ion-button color="primary" size="small" (click)="onAddSite()"><ion-icon name="add" slot="start"></ion-icon> <ion-label>Add New Site</ion-label></ion-button>
    <table class="site-list">
      <ng-container *ngFor="let site of sites">
        <tr>
          <td colspan="4">
            <ion-progress-bar [value]="siteCompletePercentage(site) / 100" class="divider-line" style="height: 3px"></ion-progress-bar>
          </td>
        </tr>
        <tr>
          <td colspan="3">
            <div class="d-flex-columns space-between">
              <div class="name-wrapper d-flex-columns">
                <ion-button size="small" (click)="onEditSiteName(site)" color="light"><ion-icon name="pencil"></ion-icon></ion-button>
                <div class="no-wrap">{{ site.name }} ({{ siteCompletePercentage(site) }}%)</div>
              </div>
              <div class="no-wrap">
                <ion-button size="small" (click)="onDuplicateSite(site)"><ion-label class="collapsable">Duplicate</ion-label><ion-icon name="duplicate"></ion-icon></ion-button>
                <ion-button size="small" (click)="onEditSite(site)"><ion-label class="collapsable">Edit Details</ion-label><ion-icon name="arrow-forward"></ion-icon></ion-button>
                <ion-button size="small" color="danger" (click)="onDeleteSite(site)"><ion-label class="collapsable">Remove Site</ion-label><ion-icon name="trash"></ion-icon></ion-button>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td class="text-center">{{ site.price ?? 0 | currency }}</td>
          <td class="text-center">
            <ion-button color="secondary" size="small" (click)="onToggleSiteEnable(site)">
              <ion-icon *ngIf="site.available" name="checkmark-sharp"></ion-icon>
              <ion-icon *ngIf="!site.available" name="close-sharp"></ion-icon>
              <ion-label *ngIf="site.available" class="collapsable">Published</ion-label>
              <ion-label *ngIf="!site.available" class="collapsable">Hidden</ion-label>
            </ion-button>
          </td>
          <td class="text-center d-flex-columns space-evenly" style="align-items:center;">
            <div>{{ site.photos ? site.photos.length : 0 }}</div>
            <ion-button size="small" (click)="onUploadSitePhotos(site)"><ion-label class="collapsable">Upload Photos</ion-label><ion-icon name="cloud-upload"></ion-icon></ion-button>
          </td>

        </tr>
        <tr>
          <td colspan="4">
            <div class="d-flex-columns">
              <curbnturf-trailer-svg-line type="classA" [opacity]="1" [secondary]="true" *ngIf="site.vehicles.classA"> </curbnturf-trailer-svg-line>
              <curbnturf-trailer-svg-line type="classB" [opacity]="1" [secondary]="true" *ngIf="site.vehicles.classB"> </curbnturf-trailer-svg-line>
              <curbnturf-trailer-svg-line type="classC" [opacity]="1" [secondary]="true" *ngIf="site.vehicles.classC"> </curbnturf-trailer-svg-line>
              <curbnturf-trailer-svg-line type="fifthWheel" [opacity]="1" [secondary]="true" *ngIf="site.vehicles.fifthWheel"> </curbnturf-trailer-svg-line>
              <curbnturf-trailer-svg-line type="travelTrailer" [opacity]="1" [secondary]="true" *ngIf="site.vehicles.travelTrailer"> </curbnturf-trailer-svg-line>
              <curbnturf-trailer-svg-line type="truckCamper" [opacity]="1" [secondary]="true" *ngIf="site.vehicles.truckCamper"> </curbnturf-trailer-svg-line>
              <curbnturf-trailer-svg-line type="teardrop" [opacity]="1" [secondary]="true" *ngIf="site.vehicles.teardrop"> </curbnturf-trailer-svg-line>
              <curbnturf-trailer-svg-line type="popupActive" [opacity]="1" [secondary]="true" *ngIf="site.vehicles.popup"> </curbnturf-trailer-svg-line>
            </div>
          </td>
        </tr>
      </ng-container>
    </table>
  </ion-card-content>
</ion-card>


